import Link from 'next/link';
import Image from 'next/image';
import {FooterNavigation, FooterLinks} from './FooterNavigation/FooterNavigation';
import Social from './Social/Social';
import NewsletterForm from './NewsletterForm';

const Footer = () => {
  return (
    <footer className='footer'>
      <div className='footer-newsletter'>
        <div className='footer-newsletter-inner'>
          <div className='footer-newsletter-text'>
            <h3 className='footer-newsletter-heading'>Stay Updated</h3>
            <p className='footer-newsletter-body'>Be first in line for Cylerian updates, events, and latest blogs.</p>
          </div>
          <div className='footer-newsletter-form'>
            <NewsletterForm />
            <p className='footer-newsletter-legal'>
              By submitting this form, you accept our{' '}
              <Link href='/terms' scroll={true}>Terms of Service</Link>
              {' '}&amp;{' '}
              <Link href='/privacy'>Privacy Policy</Link>
            </p>
          </div>
        </div>
      </div>
      <div className='container'>
        <Link href='/' className='logo' />
        <div className='navigation-container'>
          <FooterNavigation />
        </div>
        <Social />
        <div className='line'></div>
        <p className='copyright'>© CYLERIAN. All Rights Reserved.</p>
        <FooterLinks />
        <div className='footer-certs'>
          <Image src='/img/iso.png' alt='ISO 27001 Certified' width={108} height={72} unoptimized />
          <Image src='/img/soc.png' alt='SOC 2 Type 2 Certified' width={72} height={72} unoptimized />
        </div>
      </div>
    </footer>
  );
};

export default Footer;

